import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/store";
import { removeToast } from "@/store/toastSlice";
import { Toast } from "./Toast";

const GlobalToastManager: React.FC = () => {
  const dispatch = useDispatch();
  const toasts = useSelector(
    (state: RootState) => (state as any).toast?.toasts || []
  );

  const handleRemoveToast = (id: string) => {
    dispatch(removeToast(id) as any);
  };

  return (
    <div style={{ position: "fixed", top: 70, right: 20, zIndex: 9999 }}>
      {toasts.map((toast: any) => (
        <Toast
          key={toast.id}
          message={toast.message}
          secondMessage={toast.secondMessage}
          type={toast.type}
          linkId={toast.linkId}
          linkName={toast.linkName}
          onClose={() => handleRemoveToast(toast.id)}
        />
      ))}
    </div>
  );
};

export default GlobalToastManager;
